import React from 'react';
import { Typography } from '@mui/material';
import NoDataIllustration from '../../../_common/Draw/NoDataIllustration';
import styled from '@emotion/styled';

const FolderEmpty = () => (
  <Wrapper>
    <NoDataIllustration />
    <Typography variant="h6" style={{ fontSize: '1.2rem' }}>
      This folder is empty.
    </Typography>
  </Wrapper>
);

export default FolderEmpty;

const Wrapper = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(10, 5, 0)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & > svg {
    width: 100%;
    max-width: 200px;
    opacity: 0.66;
    height: auto;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }

  & h3 {
    opacity: 0.6;
  }
`;
